import { Contentful } from '@move-frontend/contentful';
import { getContentfulConfig } from './config';
import { isPreviewMode } from '../utils/isPreviewMode';

let client: Contentful;

export const contentful = () => {
	if (client) {
		return client;
	}

	const isPreview = isPreviewMode();

	const { host, previewHost, accessToken, previewAccessToken, ...config } =
		getContentfulConfig();

	client = new Contentful({
		...config,
		accessToken: isPreview ? previewAccessToken : accessToken,
		host: isPreview ? previewHost : host,
		hasCache: true,
		// We can set cache age to 0, we revalidate data on route level with next app router
		maxCacheAgeInSeconds: 0,
	});

	return client;
};
